import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiButton, SuiFileDrop, SuiSlide } from '@splashthat/sui';
import CubeLoader, { INLINE_SIZE } from 'common/components/CubeLoader';
import SplashCakeClient from 'lib/SplashCakeClient';

import { ZERO_WIDTH_SPACE } from '../../utils';
import MIME_TYPES from '../../constants/mimeTypes';

import './styles.styl';
import UploadImageIllustration from './UploadImageIllustration.svg';

const DROPZONE_HEADLINE = 'Drag and drop image here';
const DROPZONE_COPY_1 = 'Background images of blocks should be no larger than 2000x2000 pixels.';
const DROPZONE_COPY_2 = 'We recommend a maximum file size of 10 MB.';
const BUTTON_LABEL = 'Browse Your Computer';
const UPLOADING_MESSAGING = 'Uploading...';

export default class UploadSlide extends Component {
    static propTypes = {
        /* eslint-disable-next-line react/require-default-props */
        acceptedMimeTypes: PropTypes.arrayOf(PropTypes.string),
        uploadSlideCopy: PropTypes.string,
        /* eslint-disable-next-line react/no-unused-prop-types */
        isActive: PropTypes.bool,
        isUploadingImage: PropTypes.bool,
        uploadImageError: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

        onImageUploaded: PropTypes.func.isRequired,
        onImageUploadStarted: PropTypes.func.isRequired,
        onImageUploadError: PropTypes.func.isRequired,
    };

    static defaultProps = {
        isActive: false,
        isUploadingImage: false,
        uploadImageError: null,
        uploadSlideCopy: null,
    };

    static tagName = SuiSlide;

    constructor(...args) {
        super(...args);

        this.cake = new SplashCakeClient();
        this.baseClassName = 'UploadSlide';
    }

    onDropAccepted = (files, event) => {
        this.props.onImageUploadStarted();

        const file = files[0];
        this.cake
            .uploadFile(file)
            .then((response) => {
                const { url, ext } = response;

                this.props.onImageUploaded(url, ext);
            })
            .catch((errorDescriptor) => {
                this.props.onImageUploadError(errorDescriptor);
            });
    };

    onDropRejected = () => {
        this.props.onImageUploadError({ error: 'invalidFileType' });
    };

    getStatusMessagingFromState() {
        const { isUploadingImage, uploadImageError } = this.props;

        let statusMessaging;
        if (uploadImageError) {
            statusMessaging = uploadImageError;
        } else if (isUploadingImage) {
            statusMessaging = UPLOADING_MESSAGING;
        }

        return statusMessaging;
    }

    renderDropzoneContent() {
        const statusMessaging = this.getStatusMessagingFromState();
        const forceButtonActive = this.props.isUploadingImage ? true : undefined;

        return (
            <SuiContainer variation="flex-center full-height">
                <SuiContainer variation="flex-group flex-center">
                    <UploadImageIllustration />
                </SuiContainer>

                <SuiContainer variation="flex-group flex-center">
                    <SuiContainer variation="padded flex-center">
                        <h3>{DROPZONE_HEADLINE}</h3>
                    </SuiContainer>
                    {typeof this.props.uploadSlideCopy === 'string' ? (
                        this.props.uploadSlideCopy
                    ) : (
                        <div>
                            <p>{DROPZONE_COPY_1}</p>
                            <p>{DROPZONE_COPY_2}</p>
                        </div>
                    )}
                </SuiContainer>
                <SuiContainer variation="flex-group flex-center">
                    <SuiContainer variation="padded">
                        <SuiContainer variation="padded">
                            {this.props.isUploadingImage ? (
                                <CubeLoader size={INLINE_SIZE} />
                            ) : (
                                <SuiButton
                                    label={BUTTON_LABEL}
                                    isActive={forceButtonActive}
                                    className="fs-ignore-rage-clicks" /* for FullStory */
                                />
                            )}
                        </SuiContainer>
                    </SuiContainer>
                </SuiContainer>
                <SuiContainer variation="flex-group flex-center">
                    <p>{statusMessaging || ZERO_WIDTH_SPACE}</p>
                </SuiContainer>
            </SuiContainer>
        );
    }

    render() {
        const mimeTypes = this.props.acceptedMimeTypes.length ? this.props.acceptedMimeTypes : MIME_TYPES;
        return [
            <SuiSlide className={this.baseClassName} isActive={this.props.isActive}>
                <SuiContainer key={1} variation="full-height">
                    <SuiFileDrop
                        onDropAccepted={this.onDropAccepted}
                        onDropRejected={this.onDropRejected}
                        multiple={false}
                        preventDropOnDocument
                        accept={mimeTypes.join(', ')}
                    >
                        {this.renderDropzoneContent()}
                    </SuiFileDrop>
                </SuiContainer>
            </SuiSlide>,
        ];
    }
}
